import { createFileRoute } from '@tanstack/react-router'

import { AccountLayout } from '@/features/user/profile'

export const Route = createFileRoute('/_event/minha-conta')({
  component: AccountLayout
})
